import { ICancelListingBookingRequestFailedUserQuery } from '../interfaces/cancel-listing-booking-request-failed-user.query.interface';
import { ICreateListingBookingRequestsForUserQuery } from '../interfaces/create-listing-booking-requests-for-user.query.interface';

export class CreateListingBookingRequestsForUser {
    successCount: number;
    skippedCount: number;
    failedCount: number;
    failedUsers: ICancelListingBookingRequestFailedUserQuery[];

    constructor(query: ICreateListingBookingRequestsForUserQuery) {
        this.successCount = query?.success_count || 0;
        this.skippedCount = query?.skipped_count || 0;
        this.failedCount = query?.failed_count || 0;
        this.failedUsers = query?.failed_users || [];
    }
}
